// extracted by mini-css-extract-plugin
export default {"policyContainer":"rate_plan_policies_policyContainer__+33gX","policyCell":"rate_plan_policies_policyCell__ewQXA","mealContainer":"rate_plan_policies_mealContainer__Plszo"};